"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appStyleClasses = void 0;
var tslib_1 = require("tslib");
var allTransitionStyles_1 = require("./allTransitionStyles");
var bounceStyles_1 = require("./bounceStyles");
var bigHollowButtonStyles_1 = require("./button/bigHollowButtonStyles");
var actionButtonSecondaryStyles_1 = require("./button/actionButtonSecondaryStyles");
var capitalizeFirstStyles_1 = require("./capitalizeFirstStyles");
var textSingleLineStyles_1 = require("./text/textSingleLineStyles");
var blockSpacedStyles_1 = require("./list/blockSpacedStyles");
var roundActionButtonStyles_1 = require("./button/roundActionButtonStyles");
var emotion_1 = require("emotion");
var lightIconButtonStyles_1 = require("./button/lightIconButtonStyles");
var bigActionButtonStyles_1 = require("./button/bigActionButtonStyles");
var bigButtonStyles_1 = require("./button/bigButtonStyles");
var loginButtonStyles_1 = require("./loginButtonStyles");
var hollowButtonStyles_1 = require("./button/hollowButtonStyles");
var actionButtonDisabledStyles_1 = require("./button/actionButtonDisabledStyles");
var buttonDisabledStyles_1 = require("./button/buttonDisabledStyles");
var actionIconButtonStyles_1 = require("./button/actionIconButtonStyles");
var textLinkStyles_1 = require("./text/textLinkStyles");
var largeCenterIconStyles_1 = require("./icon/largeCenterIconStyles");
var listHorizontalScrollStyles_1 = require("./list/listHorizontalScrollStyles");
var inlineSpacedStyles_1 = require("./list/inlineSpacedStyles");
var actionButtonStyles_1 = require("./button/actionButtonStyles");
var actionButtonSuccessStyles_1 = require("./button/actionButtonSuccessStyles");
var actionButtonDangerStyles_1 = require("./button/actionButtonDangerStyles");
var flexSpaceBetweenStyles_1 = require("./flex/flexSpaceBetweenStyles");
var spinnerWithMessageStyles_1 = require("./spinnerWithMessageStyles");
var lightBoxCardStyles_1 = require("./lightBoxCardStyles");
var lightBoxStyles_1 = require("./lightBoxStyles");
var labelStyles_1 = require("./labelStyles");
var iconStyles_1 = require("./iconStyles");
var iconButtonStyles_1 = require("./button/iconButtonStyles");
var flexCenterCenterStyles_1 = require("./flex/flexCenterCenterStyles");
var buttonStyles_1 = require("./button/buttonStyles");
var flexCenterColumnStyles_1 = require("./flex/flexCenterColumnStyles");
exports.appStyleClasses = {
    buttonStyles: buttonStyles_1.buttonStyles,
    buttonDisabledStyles: buttonDisabledStyles_1.buttonDisabledStyles,
    capitalizeFirstStyles: capitalizeFirstStyles_1.capitalizeFirstStyles,
    actionButtonStyles: actionButtonStyles_1.actionButtonStyles,
    actionButtonSecondaryStyles: actionButtonSecondaryStyles_1.actionButtonSecondaryStyles,
    actionButtonSuccessStyles: actionButtonSuccessStyles_1.actionButtonSuccessStyles,
    bigHollowButtonStyles: bigHollowButtonStyles_1.bigHollowButtonStyles,
    actionButtonDangerStyles: actionButtonDangerStyles_1.actionButtonDangerStyles,
    bigActionButtonStyles: bigActionButtonStyles_1.bigActionButtonStyles,
    bigButtonStyles: bigButtonStyles_1.bigButtonStyles,
    actionButtonDisabledStyles: actionButtonDisabledStyles_1.actionButtonDisabledStyles,
    roundActionButtonStyles: roundActionButtonStyles_1.roundActionButtonStyles,
    flexCenterCenterStyles: flexCenterCenterStyles_1.flexCenterCenterStyles,
    flexCenterColumnStyles: flexCenterColumnStyles_1.flexCenterColumnStyles,
    flexSpaceBetweenStyles: flexSpaceBetweenStyles_1.flexSpaceBetweenStyles,
    largeCenterIconStyles: largeCenterIconStyles_1.largeCenterIconStyles,
    textLinkStyles: textLinkStyles_1.textLinkStyles,
    textSingleLineStyles: textSingleLineStyles_1.textSingleLineStyles,
    iconButtonStyles: iconButtonStyles_1.iconButtonStyles,
    iconStyles: iconStyles_1.iconStyles,
    labelStyles: labelStyles_1.labelStyles,
    lightBoxStyles: lightBoxStyles_1.lightBoxStyles,
    lightBoxCardStyles: lightBoxCardStyles_1.lightBoxCardStyles,
    lightIconButtonStyles: lightIconButtonStyles_1.lightIconButtonStyles,
    spinnerWithMessageStyles: spinnerWithMessageStyles_1.spinnerWithMessageStyles,
    inlineSpacedStyles: inlineSpacedStyles_1.inlineSpacedStyles,
    blockSpacedStyles: blockSpacedStyles_1.blockSpacedStyles,
    listHorizontalScrollStyles: listHorizontalScrollStyles_1.listHorizontalScrollStyles,
    actionIconButtonStyles: actionIconButtonStyles_1.actionIconButtonStyles,
    hollowButtonStyles: hollowButtonStyles_1.hollowButtonStyles,
    loginButtonStyles: loginButtonStyles_1.loginButtonStyles,
    bounceStyles: bounceStyles_1.bounceStyles,
    allTransitionStyles: allTransitionStyles_1.allTransitionStyles,
    selectableText: (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    -webkit-touch-callout: initial;\n    -webkit-user-select: initial;\n    -khtml-user-select: initial;\n    -moz-user-select: initial;\n    -ms-user-select: initial;\n    user-select: initial;\n  "], ["\n    -webkit-touch-callout: initial;\n    -webkit-user-select: initial;\n    -khtml-user-select: initial;\n    -moz-user-select: initial;\n    -ms-user-select: initial;\n    user-select: initial;\n  "]))),
};
var templateObject_1;
